/**
 * Cart Drawer CRO — Free Shipping Progress Bar
 * Handle:  cart-drawer-cro
 * Version: 1.3 (Global Event Listeners & MutationObserver Fix)
 * Author:  MARKOV & Partners
 */

(function () {
  'use strict';

  /* ── Money formatter ── */
  function formatMoney(cents, format) {
    if (!format) format = '€{{amount_with_comma_separator}}';
    var amount      = (cents / 100).toFixed(2);
    var amountComma = amount.replace('.', ',');
    var amountND    = String(Math.round(cents / 100));
    return format
      .replace('{{amount}}',                                  amount)
      .replace('{{amount_with_comma_separator}}',             amountComma)
      .replace('{{amount_with_apostrophe_separator}}',        amount.replace('.', '’'))
      .replace('{{amount_no_decimals}}',                      amountND)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountND)
      .replace('{{amount_no_decimals_with_space_separator}}', amountND);
  }

  function getTotal(drawer) {
    var holder = drawer.querySelector('.cdr-total-holder');
    return holder ? (parseInt(holder.dataset.total, 10) || 0) : 0;
  }

  function applyDiscount(drawer, code) {
    var btn = drawer.querySelector('.checkout-buttons a');
    if (!btn || !code) return;
    if (!btn.dataset.cdrBaseHref) {
      btn.dataset.cdrBaseHref = btn.getAttribute('href').split('?')[0];
    }
    btn.setAttribute('href', btn.dataset.cdrBaseHref + '?discount=' + encodeURIComponent(code));
  }

  function removeDiscount(drawer) {
    var btn = drawer.querySelector('.checkout-buttons a');
    if (!btn || !btn.dataset.cdrBaseHref) return;
    btn.setAttribute('href', btn.dataset.cdrBaseHref);
  }

  function launchConfetti(bar) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var colors = ['#C09A3A', '#E8C444', '#F5E08A', '#FFFFFF', '#1A1A1A', '#D4AF37'];
    var count = 55;
    for (var i = 0; i < count; i++) {
      (function (delay) {
        setTimeout(function () {
          var piece = document.createElement('div');
          piece.className = 'cdr-confetti-piece';
          piece.style.left            = (5 + Math.random() * 90) + '%';
          piece.style.background      = colors[Math.floor(Math.random() * colors.length)];
          piece.style.width           = (3 + Math.random() * 5) + 'px';
          piece.style.height          = (5 + Math.random() * 8) + 'px';
          piece.style.animationDuration = (0.85 + Math.random() * 0.9) + 's';
          piece.style.transform       = 'rotate(' + (Math.random() * 360) + 'deg)';
          bar.appendChild(piece);
          setTimeout(function () {
            if (piece.parentNode) piece.parentNode.removeChild(piece);
          }, 2600);
        }, delay);
      })(i * 22);
    }
  }

  function updateBar(drawer) {
    var bar = drawer.querySelector('.cdr-shipping-bar');
    if (!bar) return;

    var threshold    = parseInt(bar.dataset.threshold, 10) || 0;
    var discountCode = bar.dataset.discountCode || '';
    var format       = bar.dataset.moneyFormat  || '';
    var textGoal     = bar.dataset.textGoal     || 'Добави {amount} за безплатна доставка';
    var textProgress = bar.dataset.textProgress || 'Само <strong>{amount}</strong> до безплатна доставка!';
    var textUnlocked = bar.dataset.textUnlocked || '🎉 Безплатна доставка е отключена!';

    var fill  = bar.querySelector('.cdr-shipping-bar__fill');
    var msg   = bar.querySelector('.cdr-shipping-bar__msg');
    var track = bar.querySelector('.cdr-shipping-bar__track');

    var total     = getTotal(drawer);
    var pct       = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 100;
    var remaining = Math.max(0, threshold - total);
    var wasUnlocked = bar.classList.contains('cdr-shipping-bar--unlocked');

    if (fill) fill.style.width = pct.toFixed(1) + '%';

    if (track) {
      track.setAttribute('aria-valuenow', Math.round(pct));
      track.setAttribute('aria-valuetext', pct >= 100 ? textUnlocked : remaining + ' remaining');
    }

    if (pct >= 100) {
      if (!wasUnlocked) {
        bar.classList.add('cdr-shipping-bar--unlocked');
        launchConfetti(bar);
      }
      if (msg) msg.innerHTML = textUnlocked;
      applyDiscount(drawer, discountCode);
    } else {
      if (wasUnlocked) {
        bar.classList.remove('cdr-shipping-bar--unlocked');
      }
      if (msg) {
        var amountStr = formatMoney(remaining, format);
        var template  = total === 0 ? textGoal : textProgress;
        msg.innerHTML = template.replace(/\{amount\}/g, amountStr);
      }
      removeDiscount(drawer);
    }
  }

  function initDrawer(drawer) {
    if (drawer._cdrInit) return;
    drawer._cdrInit = true;

    updateBar(drawer);

    /* GLOBAL EVENT LISTENERS */
    var eventsToListen = [
      'on:cart:after-merge', 
      'cart:updated', 
      'theme:cart:updated', 
      'ajaxProduct:added'
    ];

    eventsToListen.forEach(function(evt) {
      document.addEventListener(evt, function() {
        setTimeout(function() { updateBar(drawer); }, 150);
      });
      window.addEventListener(evt, function() {
        setTimeout(function() { updateBar(drawer); }, 150);
      });
    });

    /* MUTATION OBSERVER */
    var footerNode = drawer.querySelector('[data-merge="footer"]');
    if (footerNode && typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function() {
        setTimeout(function() { updateBar(drawer); }, 100);
      });
      observer.observe(footerNode, { childList: true, subtree: true });
    }
  }

  var drawer = document.querySelector('.js-cart-drawer, cart-drawer, cart-drawer-component');
  if (drawer) initDrawer(drawer);

  document.addEventListener('shopify:section:load', function (e) {
    var d = e.target.querySelector('.js-cart-drawer, cart-drawer, cart-drawer-component');
    if (d) { d._cdrInit = false; initDrawer(d); }
  });

}());